<template>
  <div class="data-import-container pa-4">
    <v-card outlined>
      <v-card-title>
        Data Import / 数据导入
        <v-spacer></v-spacer>
        <v-icon>mdi-cloud-upload</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <!-- Import Type Selection -->
          <v-select
            v-model="importType"
            :items="importTypes"
            label="Import Type / 导入类型"
            item-text="text"
            item-value="value"
            required
            :rules="[v => !!v || 'Type is required']"
            outlined
            dense
          ></v-select>

          <!-- Region Code Input -->
          <v-text-field
            v-model="regionCode"
            label="Region Code / 区域代码"
            hint="Enter 12-14 digit code (e.g. 520202...)"
            required
            :rules="regionRules"
            outlined
            dense
          ></v-text-field>

          <!-- File Input -->
          <v-file-input
            v-model="file"
            :accept="acceptedExtensions"
            label="Select File / 选择文件"
            :hint="fileHint"
            persistent-hint
            show-size
            required
            :rules="[v => !!v || 'File is required']"
            outlined
            dense
            prepend-icon="mdi-paperclip"
          ></v-file-input>

          <!-- Error Alert -->
          <v-alert
            v-if="error"
            type="error"
            dismissible
            dense
            tile
            class="mt-2"
          >
            {{ error }}
          </v-alert>

          <!-- Success Alert -->
          <v-alert
            v-if="success"
            type="success"
            dismissible
            dense
            tile
            class="mt-2"
          >
            Upload Successful! Batch ID: {{ batchId }}
            <br>
            <span class="text-caption">Processing in background... check Import Log for status.</span>
          </v-alert>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :loading="loading"
          :disabled="!valid"
          @click="uploadFile"
        >
          Upload / 上传
          <v-icon right>mdi-upload</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from '@/axios'
import { mapState } from 'vuex'

export default {
  name: 'DataImport',
  data () {
    return {
      valid: false,
      loading: false,
      importType: 'policy',
      importTypes: [
        { text: 'Policy Data (Excel) / 投保清单', value: 'policy' },
        { text: 'Plot Data (Shapefile Zip) / 地块数据', value: 'plot' }
      ],
      regionCode: '',
      file: null,
      error: null,
      success: false,
      batchId: null
    }
  },
  computed: {
    ...mapState(['user']),
    fileHint () {
      return this.importType === 'policy'
        ? 'Upload .xlsx or .xls file'
        : 'Upload .zip file containing .shp, .shx, .dbf';
    },
    acceptedExtensions () {
      return this.importType === 'policy'
        ? '.xlsx,.xls'
        : '.zip';
    },
    regionRules () {
      return [
        v => !!v || 'Region Code is required',
        v => (v && v.length >= 12 && v.length <= 14) || 'Code must be 12-14 digits'
      ];
    }
  },
  mounted () {
    // Auto-fill region code from user if available
    if (this.user && this.user.bound_region_code) {
      this.regionCode = this.user.bound_region_code;
    }
  },
  methods: {
    async uploadFile () {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      this.error = null;
      this.success = false;

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('import_type', this.importType);
      formData.append('region_code', this.regionCode);

      try {
        const response = await axios.post('/imports/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.success = true;
        this.batchId = response.data.batch_id;
        this.file = null; // Reset file
        this.$emit('upload-success'); // Event to notify parent (e.g. to refresh logs)
      } catch (err) {
        console.error(err);
        this.error = err.response && err.response.data && err.response.data.detail
          ? err.response.data.detail
          : 'Upload failed. Please try again.';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.data-import-container {
  max-width: 600px;
  margin: 0 auto;
}
</style>
